export const configLight = {
    colorPrimary: "#76BC33",
    colorChartLabel:'#5F5959',
    colorChartLine:'#5F595920',
    // calendar
    colorTextCalendar: '#444543',
    meetingBorderColor: '#3664BD',
    meetingBgColor: '#3664BD33',
    birthdayBorderColor: '#CED232',
    birthdayBgColor: '#CED23233',
    deadlineBorderColor: '#BD3636',
    deadlineBgColor: '#BD363633',
    tableBorder:'#A4B9D14D',
    activeDay:"#76BC33",
    // popover
    deadlineBg:"#FFE6E6",
    birthdayBg:"#F9FAE8",
    birthdayColor:'#000000C2',

    meetingBg:"#E8EFFC",
    // status task
    allTask: '#646464',
    allTaskHover:"#64646433",
    doneTask: '#91CC75',
    doneTaskHover:'#91CC7533',
    progressTask: '#5470C6',
    progressTaskHover: '#5470C633',
    failedTask: "#EE6666",
    failedTaskHover: "#EE666633",
    responsibleTask:'#FAC858',
    responsibleTaskHover:'#FAC85833',
    //
    contentBg:'#FFFFFF',
    mainBg:"#F4F6F3",
    Button: {
        colorPrimary: "#76BC33",
        primaryColor: '#ffffff',
        defaultBg: "transparent",
        colorPrimaryHover: "rgba(117,188,51,0.8)"
    },
    Input: {
        hoverBorderColor: "rgb(118, 188, 51)",
        colorBorder: "rgb(222, 222, 230)",
        activeBorderColor: "rgb(118, 188, 51)",
        colorText: "rgb(81, 90, 100)",
        colorTextPlaceholder: "rgb(199, 199, 204)",
        activeShadow: ""
    },
    Typography: {
        colorTextHeading:"rgb(81, 90, 100)"
    },
    InputNumber: {
        hoverBorderColor: "rgb(118, 188, 51)",
        colorBorder: "rgb(222, 222, 230)",
        activeBorderColor: "rgb(118, 188, 51)",
        colorText: "rgb(81, 90, 100)",
        colorTextPlaceholder: "rgb(199, 199, 204)",
        activeShadow: ""
    },
    Form: {
        labelColor: "rgb(81, 90, 100)",
    },
    Layout: {
        headerBg: "rgb(255, 255, 255)",
        siderBg: "rgb(255, 255, 255)",
        footerBg: "rgb(255, 255, 255)",
        bodyBg: "#F6F8FF"
    },
    Menu: {
        itemBg: "rgb(255, 255, 255)",
        itemColor: "rgb(81, 90, 100)",
        itemActiveBg: "rgb(244, 250, 239)",
        itemHoverBg: "rgb(244, 250, 239)",
        itemSelectedBg: "#76BC33",
        itemSelectedColor: "#FFFFFF",
        groupTitleColor: "rgb(81, 90, 100)",
        subMenuItemBg: "rgba(255, 255, 255, 0)",
        activeBarBorderWidth: 8,
        collapsedIconSize: 25,
        iconSize: 18,
        itemHoverColor: "rgb(118, 188, 51)",
    },
    Dropdown: {
        colorPrimary: "rgb(81, 90, 100)",
        colorText: "rgb(81, 90, 100)",
        colorTextDescription: "rgb(81, 90, 100)",
        colorTextLightSolid: "rgb(81, 90, 100)",
        controlItemBgActive: "rgb(251, 251, 251)",
        controlItemBgActiveHover: "rgb(251, 251, 251)",
        controlItemBgHover: "rgb(251, 251, 251)",
        colorPrimaryBorder: "rgb(81, 90, 100)",
        colorBgElevated: "rgb(251, 251, 251)"
    },
    Card: {
        colorText: "rgb(81, 90, 100)",
        colorTextDescription: "rgb(81, 90, 100)",
        colorPrimary: "rgb(81, 90, 100)",
        extraColor: "rgb(81, 90, 100)",
        colorTextHeading: "rgb(81, 90, 100)",
        boxShadowCard: "box-shadow: 2px 2px 16px 0px rgba(0, 0, 0, 0.06);"
    },
    Table: {
        headerBg: "rgb(244, 250, 239)",
        fixedHeaderSortActiveBg: "rgba(118, 188, 51, 0.3)",
        colorText: "rgb(81, 90, 100)",
        colorTextHeading: "rgb(81, 90, 100)",
        rowHoverBg: "rgb(244, 250, 239)",
        footerBg: "rgb(244, 250, 239)",
        footerColor: "rgb(81, 90, 100)",
        bodySortBg: "rgb(255, 255, 255)"
    },
    Pagination: {
        colorPrimary: "rgb(118, 188, 51)",
        colorPrimaryHover: "rgb(118, 188, 51)",
        colorText: "rgb(81, 90, 100)"
    },
    DatePicker: {
        hoverBorderColor: "rgb(118, 188, 51)",
        colorBorder: "rgb(118, 188, 51)",
        activeBorderColor: "rgb(118, 188, 51)",
        colorPrimary: "rgb(118, 188, 51)"
    },
    Select: {
        colorPrimary: "rgb(118, 188, 51)",
        colorPrimaryHover: "rgb(118, 188, 51)",
        colorBorder: "#84848499",
        hoverBorderColor: "#84848499"
    },
    Calendar: {
        fontSize: 14,
        fullBg: "#FFFFFF"
    }

};
export const configDark = {
    contentBg:'#25293C',
    colorChartLabel:'#E8E8E8',
    colorChartLine:'#E8E8E820',
    // calendar
    colorTextCalendar: '#444543',
    meetingBorderColor: '#3664BD',
    meetingBgColor: '#3664BD33',
    birthdayBorderColor: '#CED232',
    birthdayBgColor: '#CED232B2',
    deadlineBorderColor: '#BD3636',
    deadlineBgColor: '#BD3636B2',
    tableBorder:'#A4B9D14D',
    activeDay:"#76BC33",
    // popover
    deadlineBg:"#A9474D",
    birthdayBg:"#ACB048",
    birthdayColor:'#FFFFFFC2',
    meetingBg:"#4161A2",
    // task status
    allTask: '#646464',
    allTaskHover:"#64646433",
    doneTask: '#91CC75',
    doneTaskHover:'#91CC7533',
    progressTask: '#5470C6',
    progressTaskHover: '#5470C633',
    failedTask: "#EE6666",
    failedTaskHover: "#EE666633",
    responsibleTask:'#FAC858',
    responsibleTaskHover:'#FAC85833',

    mainBg:"rgb(27, 31, 40)",
    Button: {
        colorPrimary: "#76BC33",
        primaryColor: '#ffffff',
        defaultBg: "transparent",
        colorPrimaryHover: "rgba(117,188,51,0.8)"

    },
    Input: {
        hoverBorderColor: "rgb(118, 188, 51)",
        colorBgContainer: "rgb(37, 43, 54)",
        colorBorder: "rgb(81, 90, 100)",
        activeBorderColor: "rgb(118, 188, 51)",
        colorText: "rgb(222, 222, 230)",
        colorTextPlaceholder: "rgb(222, 222, 230)",
        activeShadow: ""
    },
    Typography: {
        colorTextHeading:"#DEDEE6"

    },

    InputNumber: {
        hoverBorderColor: "rgb(118, 188, 51)",
        colorBgContainer: "rgb(37, 43, 54)",
        colorBorder: "rgb(81, 90, 100)",
        activeBorderColor: "rgb(118, 188, 51)",
        colorText: "rgb(222, 222, 230)",
        colorTextPlaceholder: "rgb(222, 222, 230)",
        activeShadow: ""
    },
    Form: {
        labelColor: "rgb(222, 222, 230)"
    },
    Layout: {
        bodyBg: "#171924",
        headerBg: "#25293C",
        footerBg: "#25293C",
        siderBg: "#25293C"
    },
    Menu: {
        itemBg: "#25293C",
        itemColor: "rgb(222, 222, 230)",
        itemActiveBg: "rgb(42, 57, 54)",
        itemHoverBg: "rgb(42, 57, 54)",
        itemSelectedBg: "#76BC33",
        itemSelectedColor: "#FFFFFF",
        groupTitleColor: "rgb(222, 222, 230)",
        subMenuItemBg: "#25293C",
        activeBarBorderWidth: 8,
        collapsedIconSize: 25,
        iconSize: 18,
        itemHoverColor: "rgb(118, 188, 51)"
    },
    Dropdown: {
        colorPrimary: "rgb(222, 222, 230)",
        colorText: "rgb(222, 222, 230)",
        colorTextDescription: "rgb(222, 222, 230)",
        colorTextLightSolid: "rgb(222, 222, 230)",
        controlItemBgActive: "rgb(30, 35, 44)",
        controlItemBgActiveHover: "rgb(30, 35, 44)",
        controlItemBgHover: "rgb(30, 35, 44)",
        colorBgElevated: "rgb(81, 90, 100)",
        colorPrimaryBorder: "rgb(222, 222, 230)",
    },
    Card: {
        extraColor: "rgb(81, 90, 100)",
        colorBgContainer: "#25293C",
        colorPrimary: "rgb(222, 222, 230)",
        colorText: "rgb(222, 222, 230)",
        colorTextDescription: "rgb(222, 222, 230)",
        colorTextHeading: "rgb(222, 222, 230)",
        colorBorderSecondary: "rgba(0, 0, 0, 0)",
        boxShadowCard: "box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1);"
    },
    Table: {
        headerBg: "rgb(42, 57, 54)",
        fixedHeaderSortActiveBg: "rgb(42, 57, 54)",
        colorText: "rgb(222, 222, 230)",
        colorTextHeading: "rgb(222, 222, 230)",
        rowHoverBg: "rgb(81, 90, 100)",
        footerBg: "rgb(42, 57, 54)",
        footerColor: "rgb(222, 222, 230)",
        colorBgContainer: "rgb(37, 43, 54)",
        bodySortBg: "rgba(0, 0, 0, 0)"
    },
    Pagination: {
        colorPrimary: "rgb(118, 188, 51)",
        colorPrimaryHover: "rgb(118, 188, 51)",
        colorText: "rgb(222, 222, 230)"
    },
    DatePicker: {
        hoverBorderColor: "rgb(118, 188, 51)",
        colorBorder: "rgb(118, 188, 51)",
        activeBorderColor: "rgb(118, 188, 51)",
        colorPrimaryBorder: "rgb(118, 188, 51)",
        colorText: "rgb(255, 255, 255)",
        colorPrimary: "rgb(118, 188, 51)",
        activeBg: "rgba(0, 0, 0, 0)",
        colorBgElevated: "rgb(27, 31, 40)",
        colorTextDescription: "rgb(255, 255, 255)",
        colorTextDisabled: "rgb(255, 255, 255)",
        colorTextHeading: "rgb(255, 255, 255)",
        colorIcon: "rgb(255, 255, 255)",
        colorBgContainer: "rgba(255, 255, 255, 0.01)"
    },
    Select: {
        colorPrimary: "rgb(118, 188, 51)",
        colorPrimaryHover: "rgb(118, 188, 51)",
        colorBgContainer: "rgba(255, 255, 255, 0)",
        optionSelectedBg: "rgb(42, 57, 54)",
        optionSelectedColor: "rgb(255, 255, 255)",
        selectorBg: "rgba(255, 255, 255, 0)",
        colorBgElevated: "rgb(27, 31, 40)",
        colorText: "rgb(255, 255, 255)",
        colorBorder: "rgba(255,255,255,0.6)",
       hoverBorderColor: "rgba(255,255,255,0.6)"
    },
    Calendar: {
        fontSize: 14,
        fullBg: 'rgb(37,41,60)'
    }
};


